var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNodata(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 432 302.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.05;}.cls-2{fill:red;}.cls-3{fill:#fff;}.cls-4{fill:#191919;}.cls-5,.cls-6{fill:none;}.cls-6{stroke:#d9eafe;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3.55px;}.cls-7{opacity:0.1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "obj"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 216,
    cy: 289.96,
    rx: 216,
    ry: 12.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.12,87.58l0,10.69L358.92,279a4.49,4.49,0,0,1-4.51,4.48l-212.61-.87V105a7.51,7.51,0,0,1,7.54-7.52l73.23.3,83.44.35,3.16-5.87,4.05-7.5a5.29,5.29,0,0,1,4.69-2.77l35.77.13A5.48,5.48,0,0,1,359.12,87.58Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 159.91,
    y: 78.59,
    width: 111.86,
    height: 117.42,
    rx: 5.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M193.37,95.12a3.79,3.79,0,1,0,3.79,3.79A3.79,3.79,0,0,0,193.37,95.12Zm44.95,0a3.79,3.79,0,1,0,3.79,3.79A3.79,3.79,0,0,0,238.32,95.12Zm-22.47,22.31c-7,0-13.42,2.25-17.1,6a1.51,1.51,0,0,0,1.08,2.57,1.52,1.52,0,0,0,1.08-.45c3.08-3.14,8.81-5.09,14.94-5.09s11.85,2,14.93,5.09a1.51,1.51,0,0,0,2.16-2.12C229.26,119.68,222.87,117.43,215.85,117.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M351.82,286,122.93,287a7.13,7.13,0,0,1-6.78-4.84l-36.88-110L70.7,146.52a7.1,7.1,0,0,1,6.7-9.37l5.52,0,223.39-.91a7.11,7.11,0,0,1,6.76,4.85L356,269.18l1.1,3.27,1.41,4.22A7.11,7.11,0,0,1,351.82,286Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "353.13 290.18 353.13 286.01 353.13 100.85"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 299.66,
    cy: 143.57,
    r: 31.29,
    transform: "translate(2.89 293.02) rotate(-52.33)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 312.25,
    y1: 132.05,
    x2: 288.15,
    y2: 156.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 312.25,
    y1: 156.16,
    x2: 288.15,
    y2: 132.05
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95,0c6.54,0,11,3.94,11,10.28,0,7.28-5,10.27-12,10.27l-.15,4.74H89.93l-.2-7.88h1.45c5.69,0,10.52-1.1,10.52-7.13,0-4-2.59-6.49-6.63-6.49S88.44,6.14,88.44,10h-4.3C84.1,4,88.49,0,95,0ZM91.88,35.52a3.1,3.1,0,1,1,3-3.09A3.05,3.05,0,0,1,91.88,35.52Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.09,30.19c3.82-1.93,7.61-1,9.49,2.75,2.15,4.26.09,7.5-4,9.57l1.32,2.82-2.31,1.16-2.44-4.55.84-.43c3.33-1.68,5.83-3.75,4.05-7.28a4,4,0,0,0-5.8-1.83c-2.39,1.21-3.19,3.33-2,5.61l-2.51,1.27C277.88,35.76,279.27,32.13,283.09,30.19Zm8.67,21.71a2,2,0,1,1-1.83-3.62,2,2,0,0,1,1.83,3.62Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M196.76,46.46l-9.85,8.35a3.14,3.14,0,0,1-4.41-.37l-13.6-16,.44-6.43,8.81-7.47a3.13,3.13,0,0,1,4.41.37l14.57,17.18A3.14,3.14,0,0,1,196.76,46.46Zm-27.3-8.24,13.46,15.87a2.58,2.58,0,0,0,3.64.3L196.41,46a2.59,2.59,0,0,0,.3-3.64L182.15,25.22a2.59,2.59,0,0,0-3.64-.3l-8.64,7.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "169.6 32.11 172.49 35.51 169.18 38.31 169.6 32.11"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 171.37,
    y: 33.18,
    width: 11.67,
    height: 0.39,
    transform: "translate(20.45 122.5) rotate(-40.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 172.9,
    y: 34.97,
    width: 11.67,
    height: 0.39,
    transform: "translate(19.65 123.91) rotate(-40.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 174.42,
    y: 36.77,
    width: 11.67,
    height: 0.39,
    transform: "translate(18.85 125.32) rotate(-40.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 175.94,
    y: 38.56,
    width: 11.67,
    height: 0.39,
    transform: "translate(18.05 126.73) rotate(-40.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 177.46,
    y: 40.36,
    width: 11.67,
    height: 0.39,
    transform: "translate(17.25 128.14) rotate(-40.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 178.98,
    y: 42.15,
    width: 11.67,
    height: 0.39,
    transform: "translate(16.45 129.55) rotate(-40.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 180.5,
    y: 43.95,
    width: 11.67,
    height: 0.39,
    transform: "translate(15.65 130.96) rotate(-40.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 182.02,
    y: 45.74,
    width: 11.67,
    height: 0.39,
    transform: "translate(14.85 132.36) rotate(-40.29)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M384.41,93.57l-10.14-8a3.14,3.14,0,0,1-.52-4.4l13-16.51,6.39-.85L402.23,71a3.13,3.13,0,0,1,.52,4.4L388.81,93.05A3.13,3.13,0,0,1,384.41,93.57Zm2.66-28.39L374.18,81.52a2.59,2.59,0,0,0,.43,3.63l10.14,8a2.59,2.59,0,0,0,3.63-.43L402.32,75a2.59,2.59,0,0,0-.43-3.63l-8.89-7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "393.08 64.11 390.32 67.61 386.92 64.92 393.08 64.11"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 387.52,
    y: 71.61,
    width: 11.67,
    height: 0.39,
    transform: "translate(128.96 -228.15) rotate(38.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 386.06,
    y: 73.46,
    width: 11.67,
    height: 0.39,
    transform: "translate(129.79 -226.85) rotate(38.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 384.6,
    y: 75.31,
    width: 11.67,
    height: 0.39,
    transform: "translate(130.62 -225.56) rotate(38.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 383.15,
    y: 77.16,
    width: 11.67,
    height: 0.39,
    transform: "translate(131.45 -224.26) rotate(38.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 381.69,
    y: 79,
    width: 11.67,
    height: 0.39,
    transform: "translate(132.28 -222.96) rotate(38.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 380.23,
    y: 80.85,
    width: 11.67,
    height: 0.39,
    transform: "translate(133.11 -221.66) rotate(38.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 378.78,
    y: 82.7,
    width: 11.67,
    height: 0.39,
    transform: "translate(133.94 -220.36) rotate(38.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 377.32,
    y: 84.54,
    width: 11.67,
    height: 0.39,
    transform: "translate(134.77 -219.06) rotate(38.26)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodata);
export default __webpack_public_path__ + "static/media/No data.1a7bcc3acb683270500c691712ca4695.svg";
export { ForwardRef as ReactComponent };